/**
 * NoSeatModal（空席なしポップアップ）
 * 出社登録で空席がなかったときに画像を画面全体に表示する。
 *
 * Props:
 *   isOpen  {boolean}
 *   onClose {function}
 */
import { useEffect, useRef } from 'react';

const NO_SEAT_IMAGE_PATH = '/images/life-no-seat.png';

function NoSeatModal({ isOpen, onClose }) {
  const closeButtonRef = useRef(null);

  // 開いた直後に閉じるボタンへフォーカスし、キーボードだけでも閉じられるようにする
  useEffect(() => {
    if (isOpen && closeButtonRef.current) closeButtonRef.current.focus();
  }, [isOpen]);

  // Esc キーで閉じる
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isOpen) onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="life-modal-overlay life-no-seat-overlay"
      role="presentation"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div
        className="life-no-seat-modal"
        role="dialog"
        aria-modal="true"
        aria-label="空席なし"
      >
        <img className="life-no-seat-modal__image" src={NO_SEAT_IMAGE_PATH} alt="空席なし" />
        <button
          ref={closeButtonRef}
          type="button"
          className="life-no-seat-modal__close"
          aria-label="閉じる"
          onClick={onClose}
        >
          ×
        </button>
      </div>
    </div>
  );
}

export default NoSeatModal;
